/* IU4.4.2 — progressive enhancement of Search's quick start only. */
(() => {
  'use strict';
  function initialize(scope = document) {
    scope.querySelectorAll('[data-iu-search-start]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const form = root.querySelector('form');
      const category = form.elements.iu_category;
      function syncAudience() {
        const audience = form.querySelector('[name="iu_gender"]:checked');
        if (!audience) return;
        form.action = audience.dataset.collectionUrl;
        for (const option of category.querySelectorAll('[data-women-only]')) {
          option.hidden = option.disabled = audience.value === 'Barbati';
        }
        if (category.selectedOptions[0]?.disabled) category.value = '';
      }
      form.addEventListener('change', syncAudience);
      form.addEventListener('submit', event => {
        if (event.defaultPrevented) return;
        const target = new URL(form.action, location.origin);
        if (target.origin !== location.origin) return;
        event.preventDefault();
        const selection = new FormData(form);
        target.search = '';
        for (const [name, value] of selection) {
          if (!value) continue;
          for (const part of name === 'iu_category' ? value.split('|') : [value]) {
            target.searchParams.append(name, part);
          }
        }
        location.assign(target.href);
      });
      syncAudience();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), {once: true});
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
